import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  useUploadSkusImportados,
  useUploadSkusNormais,
} from "../../../client/hooks/marketplace/marketplace.queries";
import CustomSnackbar from "../../components/Message.Component";
import EcommerceFileUpload from "../../components/ConfigComponents/EcomerceFileUpload.component";

export default function UploadXlmDialog({
  open,
  onClose,
  onSave,
  initialData,
}) {
  const [skusImportados, setSkusImportados] = useState(null);
  const [skusNormais, setSkusNormais] = useState(null);

  const [performUploadSkuImportados, setPerformUploadSkuImportados] =
    useState(false);
  const [performUploadSkuNormais, setPerformUploadSkuNormais] = useState(false);

  const {
    data: dataUploadSkuImportados,
    isError: isErrorUploadSkuImportados,
    error: errorUploadSkuImportados,
    isLoading: isLoadingUploadSkuImportados,
    refetch: refetchUploadSkuImportados,
  } = useUploadSkusImportados(skusImportados, performUploadSkuImportados);
  const {
    data: dataUploadSkuNormais,
    isError: isErrorUploadSkuNormais,
    error: errorUploadSkuNormais,
    isLoading: isLoadingUploadSkuNormais,
    refetch: refetchUploadSkuNormais,
  } = useUploadSkusNormais(skusNormais, performUploadSkuNormais);

  const [alert, setAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (initialData) {
      setSkusImportados(null);
      setSkusNormais(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, initialData]);

  function saveChanges() {
    if (dataUploadSkuImportados || dataUploadSkuNormais) {
      onSave();
    }
    if (skusImportados) {
      setPerformUploadSkuImportados(true);
    }
    if (skusNormais) {
      setPerformUploadSkuNormais(true);
    }
    setTimeout(() => {
      if (isErrorUploadSkuImportados) {
        refetchUploadSkuImportados();
      }
      if (isErrorUploadSkuNormais) {
        refetchUploadSkuNormais();
      }
    }, 300);
  }

  useEffect(() => {
    if (isErrorUploadSkuImportados || isErrorUploadSkuNormais) {
      const errorMessage =
        errorUploadSkuImportados?.response?.data?.msg ||
        errorUploadSkuNormais?.response?.data?.msg ||
        "Ocorreu um erro inesperado.";

      setErrorMsg(errorMessage);
      setAlert(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CustomSnackbar
        open={alert}
        onClose={() => setAlert(false)}
        severity={
          isErrorUploadSkuImportados || isErrorUploadSkuNormais
            ? "error"
            : "success"
        }
        message={
          isErrorUploadSkuImportados || isErrorUploadSkuNormais ? errorMsg : ""
        }
        autoHideDuration={2000}
      />
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderTop: (theme) => `4px solid ${theme.palette.primary.main}`,
            borderRadius: "0 0 8px 8px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Fazer upload de arquivos
          <IconButton onClick={() => onClose()}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {/* Aba de Upload XLS */}
          <EcommerceFileUpload
            onFilesSelected={(file1, file2) => {
              setSkusImportados(file1);
              setSkusNormais(file2);
            }}
            loadingUploadSkuImportados={isLoadingUploadSkuImportados}
            loadingUploadSkuNormais={isLoadingUploadSkuNormais}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => saveChanges()}
            color="primary"
            variant="outlined"
            sx={{
              color: "#4caf50",
              borderColor: "#4caf50",
              height: "45px",
              width: "120px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: 700,
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "#e8f5e9", // fundo verde bem claro
                borderColor: "#388e3c", // verde mais escuro no hover
              },
              "&:active": {
                transform: "scale(0.98)",
                transition: "transform 0.1s ease-in-out",
              },
              transition: "background-color 0.3s ease, transform 0.2s ease",
            }}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
